module.exports = __webpack_public_path__ + "img/SketchPnge6a6908b213c3ebb5fdea05b09f8508cfbe483daabe3c45833d7267cc477f0c4.2733d2e3.png";